import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FormControl } from '@angular/forms';
import { ProjectsService } from 'src/app/services/projects.service';
import { MainService } from 'src/app/services/main.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-promotions-configuration',
  templateUrl: './promotions-configuration.component.html',
  styleUrls: ['./promotions-configuration.component.scss'],
})
export class PromotionsConfigurationComponent implements OnInit {
  projectName: string = '';
  allAttributes: { name: string, selected: boolean }[] = [];
  filteredAttributes: { name: string, selected: boolean }[] = [];
  searchControl = new FormControl('');
  id_proj : number = 0;
  id_file : number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PromotionsConfigurationComponent>,
    private projectsS: ProjectsService,
    private main: MainService,
  ) {
    this.projectName = data.projectName || '';
    this.id_proj = this.data.id_proj;
    this.id_file = this.data.id_file;
    this.getFile();
  }

  ngOnInit(): void {
    this.searchControl.valueChanges.subscribe(value => {
      this.filterAttributes(value);
    });
  }

  filterAttributes(searchTerm: string | null): void {
    const term = (searchTerm || '').toLowerCase();
    if (!term) {
      this.filteredAttributes = [...this.allAttributes];
      return;
    }
    this.filteredAttributes = this.allAttributes.filter(attr =>
      attr.name.toLowerCase().includes(term)
    );
  }

  onSave(): void {
    let selectedAttributes = this.allAttributes
      .filter(attr => attr.selected)
      .map(attr => attr.name);

    if (selectedAttributes.length === 0) {
      selectedAttributes = ['_empty_'];
    }

    console.log("Guardando configuración:", selectedAttributes, "para el archivo ID:", this.id_file);

    this.main.ShowLoading();
    this.projectsS.updatePromoConfig(this.id_file, selectedAttributes).subscribe({
      next: (res: any) => {
        this.main.HideLoading();
                Swal.fire({
                  icon: 'success',
                  title: 'Configuración guardada',
                  text: 'Se actualizó la configuración correctamente.'
                });
       // this.dialogRef.close(true); 
      } ,
      error: (err: any) => {
        console.error(err);
        this.main.HideLoading();
                  Swal.fire({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Ocurrió un error al guardar, porfavor, intente de nuevo.'
                });
        
      }
     });
  }

  toggleSelectAllVisible(event: MatCheckboxChange): void {
    const isChecked = event.checked;
    this.filteredAttributes.forEach(filteredAttr => {
      filteredAttr.selected = isChecked;
    
      const mainAttr = this.allAttributes.find(attr => attr.name === filteredAttr.name);
      if (mainAttr) {
        mainAttr.selected = isChecked;
      }
    });
  }

  areAllVisibleSelected(): boolean {
    if (this.filteredAttributes.length === 0) {
      return false;
    }
    return this.filteredAttributes.every(attr => attr.selected);
  }

  isSomeVisibleSelected(): boolean {
    if (this.filteredAttributes.length === 0) {
      return false;
    }
    const someSelected = this.filteredAttributes.some(attr => attr.selected);
    const allSelected = this.areAllVisibleSelected();
    return someSelected && !allSelected;
  }

  getFile(){
    this.main.ShowLoading();
    this.projectsS.getPromotionData(this.id_proj).subscribe({
      next: (res: any) => {

        const attributeList: string[] = [];
        const promotionFile = res.data;
        if(promotionFile) {
          // Extraemos los atributos del archivo de promociones
          const dynamicAttributes = Object.keys(promotionFile[0] || {}).filter(key => 
            key && key.trim() !== '' && 
            key.trim().toUpperCase() !== 'CODIGO PRINCIPAL' && 
            key.trim().toUpperCase() !== 'status'
          );
          attributeList.push(...dynamicAttributes);
        }

        const config: string[] = res.config || [];
        const selectAll = config.length === 0;
        const selectNone = config.length === 1 && config[0] === '_empty_';

        this.allAttributes = attributeList.map((attrName: string) => {
          const isSelected = selectAll ? true : (selectNone ? false : config.includes(attrName));
          return {
            name: attrName,
            selected: isSelected,
          };
        });

        this.filteredAttributes = [...this.allAttributes];
        this.main.HideLoading();
      },
      error: (err: any) => {
        console.error(err);
        this.main.HideLoading();
   
        this.dialogRef.close();
      }
    });
  }


  closeDialog(): void {
    this.dialogRef.close();
  }
}